import { useEffect } from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import { closeRecordingInfo } from "../Recording/RecordingUtils";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import { useDispatch, useSelector } from "react-redux";
import { closeiOSSpeakerMsg, handleToggleAudio } from "../Twilio/AudioCall/AudioCallUtils";
import { closeAudioVideoBlockMsg } from "../../shared/dataTrackFunction";
import { handleStartStopVideo } from "../Twilio/VideoCall/VideoUtils";
import {
    setAudioStartNotificationReceivedFromHostModalOpen,
    setIsAudioButtonClickDisable,
    setScreenShareStartNotificationReceivedFromHostModalOpen,
    setVideoStartNotificationReceivedFromHostModalOpen,
} from "../../reducers/common-reducer";
import { handleClickOnStartScreenShare } from "../Twilio/ScreenShare/ScreenShareUtils";
import { AR_MARKUP_VIEW, CALL_BODY_SCREEN, EXTRACT_TEXT_VIEW, MARKUP_VIEW, MEASUREMENT_VIEW } from "../../constants/Constants";
import {
    removeAudioNotificationModal,
    removeScreenshareNotificationModal,
    removeVideoNotificationModal,
} from "../ParticipantsList/HostControlledParticipants/HostControlledParticipantUtils";
import { LogFirebase } from "../../services/firestore";
import { FIREBASE_EVENT_CATEGORY } from "../../constants/FirebaseConstants";

const CommonNotificationModal = () => {
    const localisedValues = useLanguageChange();
    const { recordingInfoOnLoad } = useSelector((state) => state.recording);
    const { showiOSAudioMsg } = useSelector((state) => state.twilioEvents);
    const {
        audioVideoBlockforPopup,
        videoPermissionDeniedMsg,
        audioPermissionDeniedMsg,
        supportLinkForAgent,
        videoStartNotificationReceivedFromHostModalOpen,
        audioStartNotificationReceivedFromHostModalOpen,
        screenShareStartNotificationReceivedFromHostModalOpen,
        currentCallBodyScreen,
    } = useSelector((state) => state.commonReducer);
    const { markupInprogress, markupLiveStream, arMarkupLiveStream } = useSelector((state) => state.markup);
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { measurementView } = useSelector((state) => state.measurement);

    /* - discard the "Ask to turn cam on" & "Ask to turn mic on" & "Ask to share screen" notification modal if below screen is available */
    useEffect(() => {
        if (
            currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN ||
            currentCallBodyScreen === CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN ||
            markupInprogress !== MARKUP_VIEW.OFF_VIEW ||
            extractTextInprogress !== EXTRACT_TEXT_VIEW.OFF_VIEW ||
            measurementView !== MEASUREMENT_VIEW.OFF_VIEW ||
            arMarkupLiveStream !== AR_MARKUP_VIEW.OFF_VIEW ||
            markupLiveStream
        ) {
            removeVideoNotificationModal();
            removeAudioNotificationModal();
            removeScreenshareNotificationModal();
        }
    }, [currentCallBodyScreen, markupInprogress, extractTextInprogress, measurementView, arMarkupLiveStream, markupLiveStream]);

    const dispatch = useDispatch();

    const handleCloseVideoStartNotificationReceivedFromHostModal = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "turn_your_cam_on_modal_for_guest_from_notification", "close");
        dispatch(setVideoStartNotificationReceivedFromHostModalOpen(false));
    };

    const handleCloseAudioStartNotificationReceivedFromHostModal = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "Unmute_your_mic_modal_for_guest_from_notification", "close");
        dispatch(setAudioStartNotificationReceivedFromHostModalOpen(false));
    };

    const handleCloseScreenShareStartNotificationReceivedFromHostModal = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "start_sharing_your_Screen_modal_for_guest_from_notification", "close");
        dispatch(setScreenShareStartNotificationReceivedFromHostModalOpen(false));
    };

    const handleUnmuteMic = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "UnmuteMic_button_click_by_guest_from_notification", "true");
        dispatch(setIsAudioButtonClickDisable(true)); // disable audio button while it create a local audio track
        handleToggleAudio();
        dispatch(setAudioStartNotificationReceivedFromHostModalOpen(false));
    };

    const handleStartScreenShare = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "StartScreenShare_button_click_by_guest_from_notification", "true");
        handleClickOnStartScreenShare();
        handleCloseScreenShareStartNotificationReceivedFromHostModal();
    };

    const handleTurnCameraOn = () => {
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "TurnCameraOn_button_click_by_guest_from_notification", "true");
        handleStartStopVideo(false, true); // isFromButtonClick, isFromAgentRequest
        dispatch(setVideoStartNotificationReceivedFromHostModalOpen(false));
    };

    return (
        <div className='notification-message'>
            {GLOBAL_MEETING_DATA.isAgent && recordingInfoOnLoad && (
                <div className='notification-message-box'>
                    <div className='notification-message-left'>
                        <div className='notification-message-left-icon'>
                            <span className='for-icon icon-recording'></span>
                        </div>
                    </div>
                    <div className='notification-message-text'>
                        <div className='notification-msg-header'>
                            <h4 className='notification-msg-title'>{localisedValues?.you_are_recording_the_conversation}</h4>
                        </div>
                        <p>
                            {localisedValues?.make_sure_participant_know_they_are_being_recorded} {localisedValues?.you_can_download_recordings_later}
                        </p>
                        <div className='notification-message-dismiss'>
                            <button className='btn text-dec-none' onClick={() => closeRecordingInfo(true)}>
                                <span className='btn-text'>{localisedValues?.dismiss}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showiOSAudioMsg && (
                <div className='notification-message-box'>
                    <div className='notification-message-text'>
                        <div className='notification-msg-header'>
                            <h4 className='notification-msg-title'>{localisedValues?.audio_issue_ios}</h4>
                        </div>
                        {CALL_DATA.localAudioMsg && <p>{localisedValues?.toggle_mic_icon_guest_msg}</p>}
                        {CALL_DATA.remoteAudioMsg && <p>{localisedValues?.toggle_mic_icon_agent_msg}</p>}
                        <div className='notification-message-dismiss'>
                            <button className='btn text-dec-none' onClick={() => closeiOSSpeakerMsg(true)}>
                                <span className='btn-text'>{localisedValues?.dismiss}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {videoStartNotificationReceivedFromHostModalOpen && (
                <div className='notification-message-box'>
                    <div className='notification-message-text'>
                        <div className='notification-msg-header'>
                            <h4 className='notification-msg-title'>{localisedValues?.turn_your_camera_on}</h4>
                            <button type='button' className='notification-close-btn' onClick={handleCloseVideoStartNotificationReceivedFromHostModal}>
                                <span className='btn-icon icon-close-light'></span>
                            </button>
                        </div>
                        <p>{localisedValues?.host_invites_you_to_turn_your_camera_on}</p>
                        <div className='notification-footer'>
                            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center justify-content-end'>
                                <div className='button'>
                                    <button className='btn default-btn-link' onClick={handleCloseVideoStartNotificationReceivedFromHostModal}>
                                        {localisedValues?.got_it}
                                    </button>
                                </div>
                                <div className='button'>
                                    <button className='btn default-btn-primary' onClick={handleTurnCameraOn}>
                                        {localisedValues?.turn_camera_on}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {audioStartNotificationReceivedFromHostModalOpen && (
                <div className='notification-message-box'>
                    <div className='notification-message-text'>
                        <div className='notification-msg-header'>
                            <h4 className='notification-msg-title'>{localisedValues?.unmute_your_microphone}</h4>
                            <button type='button' className='notification-close-btn' onClick={handleCloseAudioStartNotificationReceivedFromHostModal}>
                                <span className='btn-icon icon-close-light'></span>
                            </button>
                        </div>
                        <p>{localisedValues?.host_invites_you_to_speak_unmute_your_microphone_when_ready}</p>
                        <div className='notification-footer'>
                            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center justify-content-end'>
                                <div className='button'>
                                    <button className='btn default-btn-link' onClick={handleCloseAudioStartNotificationReceivedFromHostModal}>
                                        {localisedValues?.got_it}
                                    </button>
                                </div>
                                <div className='button'>
                                    <button className='btn default-btn-primary' onClick={handleUnmuteMic}>
                                        {localisedValues?.unmute_mic}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {screenShareStartNotificationReceivedFromHostModalOpen && (
                <div className='notification-message-box'>
                    <div className='notification-message-text'>
                        <div className='notification-msg-header'>
                            <h4 className='notification-msg-title'>{localisedValues?.start_sharing_your_screen}</h4>
                            <button
                                type='button'
                                className='notification-close-btn'
                                onClick={handleCloseScreenShareStartNotificationReceivedFromHostModal}
                            >
                                <span className='btn-icon icon-close-light'></span>
                            </button>
                        </div>
                        <p>{localisedValues?.host_invites_you_to_share_your_screen}</p>
                        <div className='notification-footer'>
                            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center justify-content-end'>
                                <div className='button'>
                                    <button className='btn default-btn-link' onClick={handleCloseScreenShareStartNotificationReceivedFromHostModal}>
                                        {localisedValues?.got_it}
                                    </button>
                                </div>
                                <div className='button'>
                                    <button className='btn default-btn-primary' onClick={handleStartScreenShare}>
                                        {localisedValues?.share_screen}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {audioVideoBlockforPopup && (
                <div className='notification-message-box'>
                    {videoPermissionDeniedMsg && audioPermissionDeniedMsg && (
                        <div className='notification-message-text'>
                            <div className='notification-msg-header'>
                                <h4 className='notification-msg-title'>{localisedValues?.cam_mic_per_denied_title}</h4>
                            </div>
                            <p>
                                {localisedValues?.cam_mic_per_denied_msg}{" "}
                                <button
                                    className='btn default-btn-link text-inline-button'
                                    onClick={() => window.open(supportLinkForAgent, "_blank")}
                                >
                                    {localisedValues?.these_instructions}
                                </button>
                                {"."}
                            </p>
                            <div className='notification-message-dismiss'>
                                <button className='btn text-dec-none' onClick={() => closeAudioVideoBlockMsg(true)}>
                                    <span className='btn-text'>{localisedValues?.dismiss}</span>
                                </button>
                            </div>
                        </div>
                    )}
                    {videoPermissionDeniedMsg && !audioPermissionDeniedMsg && (
                        <div className='notification-message-text'>
                            <h4>{localisedValues?.cam_per_denied_title}</h4>

                            <p>
                                {localisedValues?.cam_per_denied_msg}{" "}
                                <button
                                    className='btn default-btn-link text-inline-button'
                                    onClick={() => window.open(supportLinkForAgent, "_blank")}
                                >
                                    {localisedValues?.these_instructions}
                                </button>
                                {"."}
                            </p>
                            <div className='notification-message-dismiss'>
                                <button className='btn text-dec-none' onClick={() => closeAudioVideoBlockMsg(true)}>
                                    <span className='btn-text'>{localisedValues?.dismiss}</span>
                                </button>
                            </div>
                        </div>
                    )}
                    {!videoPermissionDeniedMsg && audioPermissionDeniedMsg && (
                        <div className='notification-message-text'>
                            <h4>{localisedValues?.mic_per_denied_title}</h4>

                            <p>
                                {localisedValues?.mic_per_denied_msg}{" "}
                                <button
                                    className='btn default-btn-link text-inline-button'
                                    onClick={() => window.open(supportLinkForAgent, "_blank")}
                                >
                                    {localisedValues?.these_instructions}
                                </button>
                                {"."}
                            </p>
                            <div className='notification-message-dismiss'>
                                <button className='btn text-dec-none' onClick={() => closeAudioVideoBlockMsg(true)}>
                                    <span className='btn-text'>{localisedValues?.dismiss}</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CommonNotificationModal;
